<template>
  <v-application v-if="access.inv_suppliers">
    <v-layout row class="ma-2">
      <v-flex md8>
        <v-crud-card
          name="supplier"
          to="/inventory/suppliers"
          v-bind:headers="headers"
          v-bind:data="suppliers"
          v-bind:remove="remove_suppliers"
          v-bind:num-pages="suppliers_total"
          v-model="suppliers_page"
          @change-pagination="changePagination"
          :loading_items_table_data="data_loading"
          InventorySuplier
          v-bind:add_button_name="'add_supplier'"
        >
          <template #search>
            <v-spacer />
            <v-slide-x-reverse-transition>
              <v-btn icon @click="searchActivate">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-slide-x-reverse-transition>
            <v-slide-x-reverse-transition>
              <v-text-field
                v-model="search"
                ref="search_field"
                v-if="search_text"
                autofocus
                class="mt-3 pa-0"
                append-icon="mdi-close"
                @click:append="
                  {
                    (search_text = false), (search = ''), getSuppliers();
                  }
                "
                @change="
                  {
                    (suppliers_page = 1), getSuppliers();
                  }
                "
                label="Search"
              />
            </v-slide-x-reverse-transition>
            <v-slide-x-reverse-transition>
              <v-btn icon @click="downloadSuppliers">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </v-slide-x-reverse-transition>
          </template>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Suppliers from "../../mixins/inventory/supplier";
import fileSaver from "file-saver";
import xlsx from "xlsx";

// const PageSuppliers = Object.assign(Suppliers, {
//   mounted(){
//     this.update_suppliers()
//   }
// })
export default {
  name: "InventorySupplier",
  mixins: [Suppliers],
  data: () => ({
    headers: [
      { text: "Name", value: "supplier_name" },
      { text: "Contact", value: "contact" },
      { text: "Phone number", value: "phone_number" },
      { text: "Telegram Acces", value: "telegram_acces" },
      { text: "Email", value: "email" },
    ],
    search_text: false,
    search: "",
    searchText: "123",
  }),
  methods: {
    changePagination(page) {
      this.suppliers_page = page;
      this.getSuppliers(true);
    },
    searchActivate() {
      this.search_text = true;
    },
    getSuppliers(pageChanged) {
      if (this.searchText == this.search && !pageChanged) {
        return;
      }
      this.searchText = this.search;
      this.update_suppliers(this.search);
    },
   async downloadSuppliers() {
      this.loading = true;
      await this.get_all_suppliers();

      const suppliers = Array(this.all_suppliers.length)

      for (let i = 0; i< this.all_suppliers.length; i++) {
        suppliers[i] = {
          "Supplier ID": this.all_suppliers[i]._id,
          Name: this.all_suppliers[i].supplier_name ? this.all_suppliers[i].supplier_name : '-',
          Inn: this.all_suppliers[i].inn ? this.all_suppliers[i].inn : '-',
          Email : this.all_suppliers[i].email ? this.all_suppliers[i].email : '-',
          [`${this.$t("supplier_contract")}`]: this.all_suppliers[i].contract_numbers?.join(';') ? this.all_suppliers[i].contract_numbers?.join(';') : '-',
          Contact: this.all_suppliers[i].contact ?? '-',
          Note: this.all_suppliers[i].note ? this.all_suppliers[i].note : '-',
          "Access for telegram": this.all_suppliers[i].telegram_acces ? this.all_suppliers[i].telegram_acces : '-',
        }
      }

      // this.proccesDialog = false;
      const ws = xlsx.utils.json_to_sheet(suppliers);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const excel_data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(excel_data, "Suppliers.xlsx");
    }
  },
  mounted() {
    this.headers = [
      { text: this.$t("name"), value: "supplier_name" , available: true},
      { text: this.$t("contact"), value: "contact", available: true },
      { text: this.$t("phone_number"), value: "phone_number" , available: true},
      { text: this.$t("inn"), value: "inn" , available: true},
      { text: this.$t("telegram_acces"), value: "telegram_acces", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
    beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
